module.exports = __webpack_public_path__ + "img/fluid.93de9f0b.png";